import api from "../api";
import {commit} from "lodash/seq";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        property_unit: [],
        property_units: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    property_id: [], name: [],
                    property_type_id: []
                }
            }
        },
        has_errors: false,
    }, getters: {
        loading: state => state.loading,
        property_unit: state => state.property_unit,
        property_units: state => state.property_units,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    }, mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setPropertyUnits(state, data) {
            state.property_units = data;
        },

        setPropertyUnit(state, data) {
            state.property_unit = data;
        }, setErrors(state, errors) {
            state.errors = errors
        }, hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            property_id: [], name: [],
                        }
                    }
                };
            }
        }
    }, actions: {
        async getPropertyUnit({commit}, property_unit_id) {
            try {
                const response = await api.getPropertyUnit(property_unit_id);
                commit('setPropertyUnit', response.data)
            } catch (e) {
                ElMessage.error("")
            }
        }, async getPropertyUnits({commit}, filters) {
            try {
                commit('activateLoading', 'property_unit/list', {root: true});
                const response = await api.getPropertyUnits(filters);
                commit('setPropertyUnits', response);
                commit('deactivateLoading', 'property_unit/list', {root: true});
            } catch (e) {
                console.log(e)
                ElMessage.error({
                    "message": "There was a problem fetching units for this property."
                })
            }
        },

        async createPropertyUnits({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.createPropertyUnit(data);
                ElMessage.success({
                    message: "Added unit successfully!",
                    offset: 100
                })
                commit('setLoading', false)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "Error adding unit!",
                    offset: 100
                })
                commit('setLoading', false)
            }
        },

        async createBulkUnits({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.createBulkUnits(data);
                ElMessage.success({
                    message: "Units added successfully!",
                    offset: 100
                })
                commit('setLoading', false)
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "Error adding unit!",
                    offset: 100
                })
                commit('setLoading', false)
            }
        },

        async editPropertyUnit({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editPropertyUnit(data);
                dispatch('getPropertyUnits', {
                    paginate: true,
                    property_id: data.property_id
                });
                ElMessage.success({
                    message: "Information updated successfully.",
                    offset: 100
                })
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "Error updating unit!",
                    offset: 100
                })
            }
        },

        async deletePropertyUnit({dispatch, commit}, unit) {
            try {
                commit('setLoading', true)
                await api.deletePropertyUnit(unit)
                dispatch('getPropertyUnits', {
                    paginate: true,
                    property_id: unit.property_id
                });
                ElMessage.success('Information removed successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error removing PropertyUnit Unit');
            }
        }

    }
}
